// Sengsun 企业官网 - JS 主入口
// 全局模块立即加载，页面模块按需动态加载

import { initNavigation } from './modules/navigation.js';
import { initScrollReveal } from './modules/scroll-reveal.js';
import { initBackToTop } from './modules/back-to-top.js';

// 全局初始化
document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initScrollReveal();
  initBackToTop();

  // 按页面路径动态加载模块
  const path = window.location.pathname;

  // 轮播图（首页）
  if (document.querySelector('.carousel')) {
    import('./modules/carousel.js').then(m => m.initCarousel());
  }

  // 产品分类（首页 + 产品列表页）
  if (document.querySelector('.category-nav') || document.querySelector('.product-categories')) {
    const isListPage = path.startsWith('/products') && !path.includes('/products/');
    import('./modules/category-filter.js').then(m => {
      m.initCategoryFilter({
        type: 'product',
        containerSelector: '.product-grid',
        categorySelector: '.category-nav__list, .product-categories ul',
        pageSize: isListPage ? 9 : 6,
        showPagination: isListPage,
        basePath: '/products',
      });
    });
  }

  // 新闻分类（新闻列表页）
  if (document.querySelector('.news-categories') || (path.startsWith('/news') && !path.includes('/news/'))) {
    import('./modules/category-filter.js').then(m => {
      m.initCategoryFilter({
        type: 'news',
        containerSelector: '.news-list',
        categorySelector: '.category-nav__list, .news-categories ul',
        pageSize: 10,
        showPagination: true,
        basePath: '/news',
      });
    });
  }

  // 联系表单
  if (document.querySelector('.message-form')) {
    import('./modules/contact-form.js').then(m => m.initContactForm());
  }

  // 图片灯箱（产品详情/新闻详情）
  if (document.querySelector('.product-detail-content, .news-detail-content, .rich-content')) {
    import('./modules/lightbox.js').then(m => m.initLightbox());
  }

  // 合作伙伴滚动
  if (document.querySelector('.partners-track')) {
    import('./modules/partners.js').then(m => m.initPartners());
  }
});
